export default "__VITE_ASSET__5FcG1QB9__"